export default __webpack_public_path__ + "static/media/roompage-table-user.45943eef.svg";